import { InfoUsuario } from '@utils';

const { REACT_APP_API } = window.env;

const verificaErro = async (response, headers, body) => {
  const responseText = await response.text();

  try {
    const responseObject = JSON.parse(responseText);

    if (response.ok) return responseObject;
    throw new Error(responseObject.message || responseObject.mensagem);
  } catch (e) {
    throw new Error(e.message);
  }
};

const getHeaders = (headers = {}) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  ...authorization(),
  ...headers,
});

export const download = (url, fileName, headers) => {
  let anchor = document.createElement('a');
  const proxy = 'https://cors-anywhere.herokuapp.com/';
  document.body.appendChild(anchor);
  try {
    return fetch(proxy + url, { headers })
      .then((response) => response.blob())
      .then((blobby) => {
        let objectUrl = window.URL.createObjectURL(blobby);

        anchor.href = objectUrl;
        anchor.download = fileName;
        anchor.click();

        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(anchor);
        return;
      });
  } catch (e) {
    throw new Error(e.message);
  }
};

export const post = (api, body, adicionalHeaders = {}) => {
  const headers = getHeaders(adicionalHeaders);

  return fetch(getPath(api), {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  }).then((response) => {
    return verificaErro(response, headers, body);
  });
};

export const get = (api, adicionalHeaders = {}) => {
  const headers = getHeaders(adicionalHeaders);

  return fetch(getPath(api), {
    method: 'GET',
    headers,
  }).then((response) => {
    return verificaErro(response, headers);
  });
};

export const del = (api, adicionalHeaders = {}) => {
  const headers = getHeaders(adicionalHeaders);

  return fetch(getPath(api), {
    method: 'DELETE',
    headers,
  }).then((response) => {
    return verificaErro(response, headers);
  });
};

export const put = (api, body, adicionalHeaders = {}) => {
  const headers = getHeaders(adicionalHeaders);

  return fetch(getPath(api), {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  }).then((response) => {
    return verificaErro(response, headers, body);
  });
};

export const authorization = () => {
  if (!InfoUsuario.hasUser()) return {};

  const infoUsuario = InfoUsuario.get();
  return {
    token: `Bearer ${infoUsuario.token}`,
  };
};

const getPath = (api) => {
  if (api.toLowerCase().startsWith('http')) {
    return api;
  }
  return REACT_APP_API + api;
};
